export const PermissionCodes = {
  userCreationPermission: 2,
  cprNoAccess: 3,
  cprViewOnlyAccess: 4,
  cprFullAccess: 5,
  salesOrderNoAccess: 6,
  salesOrderViewOnlyAccess: 7,
  salesOrderFullAccess: 8
} as const;

export const NotificationTypes = {
  message: 1,
  alert: 2
} as const;

export const MassNotificationFilterTypes = {
  account: 0,
  serviceProvider: 1,
  spGroup: 2
} as const;

export const OrderStatus = {
  Unacknowledged: 0,
  InProcess: 1,
  Dispatched: 2,
  TripComplete: 3,
  Invoiced: 4,
  VoidCancelled: 5,
  Open: 6
} as const;

export const OrderStatusLabels: Record<number, string> = {
  0: 'Unacknowledged',
  1: 'In Process',
  2: 'Dispatched',
  3: 'Trip Complete',
  4: 'Invoiced',
  5: 'Void/Cancelled',
  6: 'Open'
};

export function getOrderStatusLabel(status: number): string {
  return OrderStatusLabels[status] ?? `Unknown (${status})`;
}

export const BillingTypeLabels: Record<number, string> = {
  0: 'Sales Invoice',
  1: 'Vendor Invoice',
  2: 'Consolidated Recap',
  3: 'Credit',
  4: 'Rebill Invoice'
};

export function getBillingTypeLabel(billingType: number): string {
  return BillingTypeLabels[billingType] ?? `Unknown (${billingType})`;
}

export enum UserPreference {
  CalendarSoAndCprSameTime = 0,
  CalendarProductQty = 1,
  HomePageSalesOrders = 2,
  HomePageRetrievals = 3,
  HomePageNotifications = 4,
  HomePageBilling = 5,
  EmailSalesOrders = 6,
  EmailRetrievals = 7
}
